import clsx from "clsx";
import { GLOBAL_UPLOAD_OVERLAY_Z } from "@/features/globalUpload/globalUploadLayers";

export function GlobalFileDropOverlay({
  active,
  zIndexClass = GLOBAL_UPLOAD_OVERLAY_Z,
}: {
  active: boolean;
  zIndexClass?: string;
}) {
  if (!active) return null;

  return (
    <div
      className={clsx(
        "pointer-events-none fixed inset-0 flex items-center justify-center bg-black/35",
        zIndexClass,
      )}
      aria-hidden
    >
      <div className="rounded-2xl border-2 border-dashed border-white bg-black/60 px-16 py-12 text-center text-lg text-white">
        <div className="mb-2 text-4xl" aria-hidden>
          📎
        </div>
        <p>Dateien hierher ziehen, um sie einem Projekt zuzuordnen …</p>
      </div>
    </div>
  );
}
